import { render, staticRenderFns } from "./SelectLang.vue?vue&type=template&id=1c0fe90e&scoped=true&"
import script from "./SelectLang.vue?vue&type=script&lang=js&"
export * from "./SelectLang.vue?vue&type=script&lang=js&"
import style0 from "./SelectLang.vue?vue&type=style&index=0&id=1c0fe90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0fe90e",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QBtn});
